import React from "react";
import { decryptBase64, removeAuth, setAuthEx } from "../../common/Helpers";
import { PARAM_NAME_PW } from "../../configurations/staticTypes.config";
import { WEB_AUTH_URL } from "../../configurations/paths.config";

  async function SetAuth() {
    let queryTk = new URLSearchParams(window.location.search).get('tk')

    if (queryTk !== null && queryTk !== undefined) {
            let stringToBase64 = decryptBase64(queryTk, PARAM_NAME_PW);
            await	setAuthEx(stringToBase64);

            window.location.href = (WEB_AUTH_URL)
    }
    else {
        await removeAuth();
        //////window.location.href = (WEB_AUTH_URL)
    }

    return (
        <>

        </>
    );
};
    
export default SetAuth;
    